var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'Loader ' + _vm.variant + ' ' + _vm.display},[_c('div',{staticClass:"spinner spinner3"}),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }